import { ICountryData, ICurrencyData } from "@/entities";
import { BACKEND_BASE_URL, IPageRequest, IPageResponse, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { ICurrencyService } from "./currency.types";

export class CurrencyService implements ICurrencyService {
  async getCurrenciesPage(params: IPageRequest): Promise<IPageResponse<ICurrencyData> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<ICountryData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/currency`, { params })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
